import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { round } from 'lodash';
import { roundNumberToStringWithDecimals } from '../../../../../../../utils';
import { QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM_TYPES } from '../../../constants';

export default function Total({
  getText,
  total,
  inputValues,
  decimals = 0,
  openEndedSign,
  openEndedConstantSumType,
}) {
  const inputsTotal = useMemo(() => {
    const hasFilledInputs = Object.values(inputValues).some((value) => value);
    if (!hasFilledInputs) {
      return 0;
    }
    let currentInputTotal = '';
    currentInputTotal = Object.values(inputValues)
      .filter((value) => value)
      .reduce((t, value) => t + parseFloat(value), 0);

    currentInputTotal = roundNumberToStringWithDecimals(
      currentInputTotal,
      decimals,
    );

    return currentInputTotal;
  }, [inputValues, decimals]);

  if (
    openEndedConstantSumType !==
    QUESTION_MATRIX_OPEN_ENDED_CONSTANT_SUM_TYPES.MUST_TOTAL
  ) {
    return getText('matrixConstinousSumOpenEndedTotal').replace(
      'YYYY',
      inputsTotal,
    );
  }

  const remaining = total - inputsTotal;
  const isTotalInvalid = remaining !== 0;
  // we decided we don't want to show negative values on the remaining number
  const sanitisedRemaining = remaining >= 0 ? round(remaining, decimals) : 0;
  const className = isTotalInvalid
    ? 'answer--matrix-open-ended-row-total-invalid'
    : 'answer--matrix-open-ended-row-total-valid';
  const text = getText('matrixConstantSumOpenEndedTotal')
    .replace(
      'YYYY',
      `<span class="${className}">${inputsTotal} ${openEndedSign}</span>`,
    )
    .replace('XXXX', sanitisedRemaining);

  // eslint-disable-next-line react/no-danger
  return <span dangerouslySetInnerHTML={{ __html: text }}></span>;
}

Total.propTypes = {
  getText: PropTypes.func,
  total: PropTypes.number,
  inputValues: PropTypes.any,
  decimals: PropTypes.any,
  openEndedSign: PropTypes.any,
  openEndedConstantSumType: PropTypes.string,
};
